import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bookmark, Share2 } from 'lucide-react';
import Badge from '../UI/Badge';
import { timeAgo } from '../../utils/formatters';

export default function JobCard({ job, view = 'list', showMatchScore = false, onSave, onMatch }) {
	const navigate = useNavigate();
	const salary = job.salaryRange ? formatSalary(job.salaryRange) : '';
	const match = job.matchPercentage || job.matchScore;
	return (
		<div
			className={`border rounded-lg p-4 hover:shadow-md transition cursor-pointer bg-white ${view === 'grid' ? '' : 'flex items-start gap-4'}`}
			onClick={() => navigate(`/jobs/${job._id}`)}
		>
			<div className="w-12 h-12 rounded bg-gray-100 flex items-center justify-center flex-shrink-0">
				{job.companyId?.logo ? <img src={job.companyId.logo} alt="" className="w-12 h-12 object-contain" /> : <span className="text-xs">Logo</span>}
			</div>
			<div className="flex-1">
				<h3 className="font-semibold text-gray-900">{job.title}</h3>
				<p className="text-sm text-gray-600">{job.companyId?.companyName || 'Company'}</p>
				<div className="text-xs text-gray-500 mt-1">
					{job.location} • {job.employmentType?.replace('-', ' ') || ''}
				</div>
				<div className="mt-2 flex flex-wrap items-center gap-2">
					{job.employmentType && <Badge text={job.employmentType} variant="info" />}
					{salary && <Badge text={salary} variant="neutral" />}
					<Badge text={timeAgo(job.postedDate)} variant="neutral" />
					{showMatchScore && typeof match === 'number' && <Badge text={`Match ${match}%`} variant={match > 75 ? 'success' : match >= 50 ? 'warning' : 'danger'} />}
				</div>
			</div>
			<div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
				<button className="p-2 hover:bg-gray-100 rounded" title="Save" onClick={onSave}>
					<Bookmark className="w-5 h-5" />
				</button>
				<button
					className="p-2 hover:bg-gray-100 rounded"
					title="Share"
					onClick={() => {
						const url = `${window.location.origin}/jobs/${job._id}`;
						if (navigator.share) navigator.share({ title: job.title, url });
						else {
							navigator.clipboard.writeText(url);
							alert('Link copied');
						}
					}}
				>
					<Share2 className="w-5 h-5" />
				</button>
			</div>
		</div>
	);
}

function formatSalary(sr) {
	const min = sr.min ? `$${sr.min}` : '';
	const max = sr.max ? `$${sr.max}` : '';
	const cur = sr.currency || 'USD';
	return [min, max].filter(Boolean).join(' - ') + (cur ? ` ${cur}` : '');
}


